/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popExtraInvite.vue?vue&type=template&id=fc24c69a&scoped=true"
import script from "./popExtraInvite.vue?vue&type=script&lang=js"
export * from "./popExtraInvite.vue?vue&type=script&lang=js"
import style0 from "./popExtraInvite.vue?vue&type=style&index=0&id=fc24c69a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc24c69a",
  null
  
)

export default component.exports